import { Controller } from "@hotwired/stimulus";
import CheckboxSelectAll from "stimulus-checkbox-select-all"

export default class extends CheckboxSelectAll {
  unselectAll() {
    this.checkboxTargets.forEach(e => {
      e.checked = false;
      this.triggerInputEvent(e);
    });
  }

  selectAll() {
    this.checkboxTargets.forEach(e => {
      e.checked = true;
      this.triggerInputEvent(e);
    });
  }
}
